var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 11.7651V7.20927C17.2162 6.95854 17.0337 1.54691 17.0266 1.03811V1H12.5608V18.7433C12.5595 20.7557 10.9739 22.3858 9.01957 22.3844C7.06521 22.3831 5.48225 20.7504 5.48355 18.7379C5.48485 16.7254 7.07041 15.0954 9.02476 15.0967C9.37278 15.0967 9.71885 15.1502 10.0519 15.2545V10.5549C5.66081 9.96724 1.63848 13.1571 1.06776 17.6788C0.497032 22.2006 3.59478 26.3425 7.9859 26.9302C12.377 27.5179 16.3994 24.328 16.9701 19.8063C17.0142 19.454 17.037 19.0989 17.037 18.7433C17.037 18.6276 17.0337 18.5126 17.0292 18.3983V9.66102C19.0868 11.6 23 11.7651 23 11.7651Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}

export default SvgTiktok;